export const Loader = () => {
  return <div>LOADING...</div>;
};
